"use strict";

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Time = void 0;

var Time =
/*#__PURE__*/
function () {
  function Time() {
    var nanos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, Time);

    this.nanos = nanos;
  }

  _createClass(Time, [{
    key: "asSeconds",
    value: function asSeconds() {
      return this.nanos / 1e9;
    }
  }, {
    key: "asMillis",
    value: function asMillis() {
      return this.nanos / 1e6;
    }
  }, {
    key: "asMicros",
    value: function asMicros() {
      return this.nanos / 1000;
    }
  }, {
    key: "asNanos",
    value: function asNanos() {
      return Math.round(this.nanos);
    }
  }], [{
    key: "fromNanos",
    value: function fromNanos(nanos) {
      return new Time(nanos);
    }
  }, {
    key: "fromMicros",
    value: function fromMicros(micros) {
      return new Time(micros * 1000);
    }
  }, {
    key: "fromMillis",
    value: function fromMillis(ms) {
      return new Time(ms * 1e6);
    }
  }, {
    key: "fromSeconds",
    value: function fromSeconds(seconds) {
      return new Time(seconds * 1e9);
    }
  }, {
    key: "from",
    value: function from(time) {
      return new Time(time.asNanos());
    }
  }]);

  return Time;
}();

exports.Time = Time;
Time.ZERO = new Time(0);